import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { isPartialDate } from 'neuro-utils';
import { formatPartialDate } from 'Utility/date';
import { sortDocuments } from 'Utility/randomUtil';
import TileContentMaker from 'Components/DashboardTile/TileContentMaker';
import { DescriptionText } from 'Components/DashboardTile/TileContentMaker/components/common/commonComponents';

const fm = (id: string, values?: { [key: string]: string | number | null }): React.JSX.Element => (
  <FormattedMessage id={id} values={values} />
);

const edssStepFormatter = (value: number): string => {
  return value !== 0 && value !== 10 ? value.toFixed(1) : value.toString();
};

const NeurologicalStatusAndEDSSDash = ({ documents }: IOwnProps): React.JSX.Element => {
  const latestNeurologicalStatusAndEDSS = documents.sort((n1, n2) =>
    sortDocuments([{ type: 'date', sortField: 'date' }])(n1, n2),
  )[0];

  const edssStep = latestNeurologicalStatusAndEDSS?.edssStep;

  return (
    <>
      <TileContentMaker
        type="bigHeaderInfo"
        bigHeaderText={edssStep || edssStep === 0 ? `${edssStep}` : null}
        bigHeaderTextSubheader={fm('neurologicalStatusAndEDSS.edssStep.title')}
        data={[
          {
            title: fm('general.date'),
            value: isPartialDate(latestNeurologicalStatusAndEDSS?.date)
              ? formatPartialDate(latestNeurologicalStatusAndEDSS.date)
              : '',
            key: 'edssdate',
          },
        ]}
      />
      <DescriptionText>
        {typeof edssStep === 'number'
          ? fm(`neurologicalStatusAndEDSS.edssStep.opts.${edssStepFormatter(edssStep)}`)
          : ''}
      </DescriptionText>
    </>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'neurologicalStatusAndEDSS'>[];
}

export default NeurologicalStatusAndEDSSDash;
